import { render, staticRenderFns } from "./DetalhesAlunoPage.vue?vue&type=template&id=852f9b22"
import script from "./DetalhesAlunoPage.vue?vue&type=script&lang=js"
export * from "./DetalhesAlunoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports